import styled from 'styled-components';

import { Colors } from 'theme/colors';

export { SwitchButton, SwitchContainer, SWITCH_WIDTH } from './styles.native';

export const KNOB_WIDTH = 25;

export const Overlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: ${Colors.alto};
  border-radius: 15px;
`;

export const Knob = styled.div`
  width: ${KNOB_WIDTH}px;
  height: ${KNOB_WIDTH}px;
  border-radius: ${KNOB_WIDTH / 2}px;
  background-color: ${Colors.white};
`;
